module.exports = __webpack_public_path__ + "static/img/withdraw_n_selected.511261ca.svg";